import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { FooterComponent } from '@rd/core/components/footer/footer.component';
import { UrlUtilsService } from '@rd/core/services/url-utils/url-utils.service';
import { BRAND_NAME } from '@rd/core/tokens/rd-lib.token';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'vma-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class VmaFooterComponent
  extends FooterComponent
  implements OnInit, OnDestroy
{
  @HostBinding('class.vma-core-main-footer') componentClass = true;

  destroy$ = new Subject();

  faqsUrl: URL;
  privacyPolicyUrl: URL;
  tncsUrl: URL;
  contactUsUrl: URL;

  constructor(
    @Inject(BRAND_NAME) protected brandName: string,
    protected urlUtilService: UrlUtilsService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
  ) {
    super(brandName, urlUtilService);

    this.faqsUrl = new URL(
      'https://virginmoney.com.au/virgin-money-app/in-app/help-and-support/faqs/loyalty',
    );
    this.tncsUrl = this.urlUtilsService.tncsUrl();
    this.privacyPolicyUrl = this.urlUtilsService.privacyPolicyUrl();
    this.contactUsUrl = new URL(
      'https://virginmoney.com.au/virgin-money-app/in-app/help-and-support/get-in-touch',
    );
  }

  ngOnInit(): void {
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.cdRef.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  shouldShowFooter(): boolean {
    const ROUTE_URLS = ['/offers', '/campaigns'];
    const routeUrlWithoutParameter = this.router.url.split('?')[0];
    const whitelistedRoute = !!ROUTE_URLS.find(
      (url) => url === routeUrlWithoutParameter,
    );

    return !whitelistedRoute;
  }

  getCurrentYear(): number {
    return new Date().getFullYear();
  }
}
